import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/device'

export const get = async (queryParam, region) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
    params: params,
    headers: {
      'X-Region': region,
    },
  })

  return response?.data
}

export const mirroring = async (data, region) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/mirror`,
    headers: {
      'X-Region': region,
    },
    data,
  })
  return response
}

export const update = async (data, imei, region) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${imei}`,
    headers: {
      'X-Region': region,
    },
    data,
  })

  return response
}

export const command = async (data, imei, region) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/${imei}/command`,
    headers: {
      'X-Region': region,
    },
    data,
  })

  return response
}

export const create = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}`,
    data: data,
  })

  return response
}

export const uploadFile = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/import`,
    data: data,
  })

  return response
}

// Tambahan: GET by IMEI
export const getByImei = async (imei, region) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${imei}`,
    headers: {
      'X-Region': region,
    },
  })

  return response?.data
}

export const download = async (queryParam, region) => {
  const params = {
    page: queryParam?.page || undefined,
    limit: queryParam?.limit || undefined,
    sorts: queryParam?.sorts?.length > 0 ? queryParam.sorts : undefined,
    search: queryParam?.search || undefined,
    filters: queryParam?.filters || undefined,
  }

  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/export`,
    params: params,
    headers: {
      'X-Region': region,
      'Accept-Language': process.env.VUE_APP_I18N_LOCALE,
    },
  })

  return response?.data
}

export const iccidCheck = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: `${baseEndpoint}/iccid/check`,
    data: data,
  })

  return response
}
